import { GET_MESSAGES, GET_MESSAGE } from './../constants/actionTypes'
import get from 'lodash/get'

const messages = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_MESSAGES: {
      const page = get(action, 'data.pageInfo', {})
      const messages =
        page.page === 1
          ? get(action, 'data.gangwayMessages', [])
          : [
              ...get(store, 'messages', []),
              ...get(action, 'data.gangwayMessages', [])
            ]
      return {
        page,
        messages
      }
    }
    default:
      return store
  }
}

const message = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_MESSAGE:
      return action.data.data
    default:
      return store
  }
}

export { messages, message }
